/**
 * On page navigation 
 */
$('.page-columns__side ul a').on('click', function (e) {
  e.preventDefault();
  var section = $(this).attr('href');
  console.log(section);

  $([document.documentElement, document.body]).animate({
    scrollTop: $(section).offset().top - $('.Header__Wrapper').outerHeight(),
  }, 1500);
});

/**
 * Size Guide tabs
 */
const activateTab = function($link) {
  $link.closest('.size-guide-nav__item--top').addClass('active');

  $('.js-size-guide-intro').hide();
  $('.js-size-guide-table').hide();
  $('.js-size-guide-img').hide();
  $('.js-size-guide-tip').hide();

  var intro = $link.data('intro');
  var table = $link.data('table');
  var tips = $link.data('tips') ? $link.data('tips').split(',') : [];
  var img = $link.data('img');

  if (intro) {
    $('.js-size-guide-intro.' + intro).show();
  }

  if (table) {
    $('.js-size-guide-table.' + table).show();
  }

  if (img) {
    var $img = $('.js-size-guide-img.' + img);
    $img.attr('src', $img.data('src')).show();
  }

  tips.forEach(function(item) {
    $('.js-size-guide-tip.' + item).show();
  }); 
};

$('.size-guide-nav a').on('click', function(e) {
  e.preventDefault();
  var $link = $(this);
  $link.closest('.size-guide-nav__list--sub').addClass('hide');
  $('.size-guide-nav .size-guide-nav__item--top.active').removeClass('active');
  $('.size-guide-nav .size-guide-nav__list--top.open').removeClass('open');
  activateTab($link);
});

$('.size-guide-nav__item--top').on('click', function() {
  $(this).toggleClass('open');
});

$('.size-guide-nav__list--sub').on('mouseout', function() {
  $(this).removeClass('hide');
});

var $firstLink = $('.size-guide-nav a').first();

if ($firstLink.length > 0) {
  activateTab($firstLink);
}